import { useLocation } from "react-router-dom";
import Login from "./Login";
import Registration from "./Registration";
import LandingHeader from "../../Components/Landing/LandingHeader";
import LandingFooter from "../../Components/Landing/LandingFooter";

export default function AuthPage() {

  const location = useLocation();
  const isSignUp = location.pathname.endsWith('/registration');

  return (
    <div className="flex min-h-screen flex-col font-jakarta text-ink antialiased">
      <LandingHeader />
      <section className="flex flex-1 flex-col">
        {isSignUp ? <Registration /> : <Login />}
      </section>
      <LandingFooter />
    </div>
  )
}
